import axios from 'axios'

const comentarios = {

    PostCrearComentario: (id,modelo,datos) => axios.post(`${id}/${modelo}/crear-comentario`,datos),
    GetListarComentario: (id,modelo, params={}) => axios.get(`${id}/${modelo}/listar-comentario`, {params})
}
export default comentarios
